import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  id?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  id
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-185" data-mp="3f25av1fguej3">
      {eyebrow ? <p className="flex items-center justify-center gap-3 text-[10px] font-bold uppercase tracking-[0.24em] text-mint sm:gap-4 sm:text-xs sm:tracking-[0.28em]" data-id="element-186" data-mp="3jzneccaps1jp">
          <span className="h-px w-6 bg-mint-deep/70 sm:w-8" aria-hidden="true" data-id="element-187" data-mp="bmpu7hcl16oz" />
          {eyebrow}
          <span className="h-px w-6 bg-mint-deep/70 sm:w-8" aria-hidden="true" data-id="element-188" data-mp="glawdmbea0g2" />
        </p> : null}
      <h2 id={id} className="display-tight mt-5 font-display text-[28px] uppercase text-paper sm:mt-6 sm:text-[48px]" data-id="element-189" data-mp="1spq9it1e7hu">
        {title}
      </h2>
      {subtitle ? <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-paper-dim sm:mt-5 sm:text-lg" data-id="element-190" data-mp="uhelj17evilo">
          {subtitle}
        </p> : null}
    </div>;
}